import PropTypes from 'prop-types';
import React from 'react';
import styles from './input.module.css';

/**
 * Generic Input component that accepts any native HTML input props.
 * @param {React.InputHTMLAttributes<HTMLInputElement>} props
 */
export const Input = React.forwardRef(({ className = '', ...props }, ref) => {
	// Combine passed className with default input style
	const inputClass = `${styles.input} ${className}`.trim();
	return <input ref={ref} className={inputClass} {...props} />;
});

Input.propTypes = {
	className: PropTypes.string,
};
